export var CatalogDataType;
(function (CatalogDataType) {
    CatalogDataType["Broadband"] = "Broadband";
    CatalogDataType["Bundle"] = "Bundle";
    CatalogDataType["CrpPlanExisting"] = "CrpPlanExisting";
    CatalogDataType["CrpPlanNew"] = "CrpPlanNew";
    CatalogDataType["DTV"] = "DTV";
    CatalogDataType["DTVNOW"] = "DTVNOW";
    CatalogDataType["IPTV"] = "iptv";
    CatalogDataType["Offers"] = "Offers";
    CatalogDataType["Wireless"] = "Wireless";
    CatalogDataType["SNG"] = "SNG";
    CatalogDataType["CARTCHECKOUT"] = "cartcheckout";
    CatalogDataType["WIRELESSINTERSTITIAL"] = "wirelessInterstitial";
})(CatalogDataType || (CatalogDataType = {}));
export var SentryTeam;
(function (SentryTeam) {
    SentryTeam["PLATFORM_UI"] = "Platform UI";
    SentryTeam["BROADBAND"] = "Broadband";
    SentryTeam["CRP_PLAN_EXISTING"] = "Crp Plan Existing";
    SentryTeam["CRP_PLAN_NEW"] = "Crp Plan New";
    SentryTeam["DTV"] = "DTV";
    SentryTeam["DTVNOW"] = "DTVNow";
    SentryTeam["IPTV"] = "IPTV";
    SentryTeam["Offers"] = "Offers";
    SentryTeam["WIRELESS"] = "Wireless";
    SentryTeam["SNG"] = "SNG";
    SentryTeam["BUNDLE"] = "Bundle";
})(SentryTeam || (SentryTeam = {}));
/* list of namespaces which is being used by lobs for their stat-manager */
export var appShellNameSpace = 'appShell';
export var LobStateManagerNameSpaces = ['DTVS', 'WIRELESS', 'Broadband', 'IPTV', 'Bundles', 'CHECKOUT', 'CART', appShellNameSpace];
export var RouteUrlTypes;
(function (RouteUrlTypes) {
    RouteUrlTypes["CHECKOUT"] = "/checkout";
    RouteUrlTypes["CART"] = "/cart";
    RouteUrlTypes["DIRECTV"] = "/directv";
    RouteUrlTypes["DTVNOW"] = "/dtvnow";
    RouteUrlTypes["WIRELESS"] = "/wireless";
    RouteUrlTypes["PREPAID"] = "/wireless/prepaid";
    RouteUrlTypes["WIRELESSINTERSTITIAL"] = "/wireless/upsell-offer-interstitial";
    RouteUrlTypes["BROADBAND"] = "/broadband";
    RouteUrlTypes["IPTV"] = "/iptv";
    RouteUrlTypes["BUNDLE"] = "/bundles";
    RouteUrlTypes["OFFERS"] = "/offers";
    RouteUrlTypes["DTVSPECIALOFFERS"] = "specialOffer=OSPREY";
    RouteUrlTypes["LOGIN"] = "/login";
})(RouteUrlTypes || (RouteUrlTypes = {}));
/* add urls where we need to show (due Today + due on first bill)  */
export var BaseUrlsToShowDueFirstBill = [
    RouteUrlTypes.DIRECTV,
    RouteUrlTypes.BROADBAND,
    RouteUrlTypes.WIRELESS,
    RouteUrlTypes.IPTV,
    RouteUrlTypes.BUNDLE,
];
export var AllowedBaseUrls = [
    RouteUrlTypes.DIRECTV,
    RouteUrlTypes.DTVNOW,
    RouteUrlTypes.WIRELESS,
    RouteUrlTypes.BROADBAND,
    RouteUrlTypes.OFFERS,
    RouteUrlTypes.BUNDLE,
    RouteUrlTypes.DTVSPECIALOFFERS,
    RouteUrlTypes.IPTV,
    RouteUrlTypes.PREPAID,
    RouteUrlTypes.WIRELESSINTERSTITIAL,
];
//# sourceMappingURL=MainView.container.props.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/MainView/MainView.container.props.js
// module id = 93
// module chunks = 8